$(document).ready(function() {

	$(".comparison__col").fadeIn('fust');


	$('.comparison__list').each(function(el) {
		new SimpleBar($('.comparison__list')[el], {
			autoHide: false,
			direction: 'rtl',
		})
	});

	$(document.body).on("click", ".remove-choose", function() {
		$('.checkboxAll').each(function() {
			$(".checkboxAll").prop('checked', false);
		})
		$('.checkboxAll_c').each(function() {
			$(".checkboxAll_c").prop('checked', false);
		})

	});


	$("#selectAll").click(function() {
		// console.log('selectAll');

		if (this.checked) {
			// console.log('checked');

			$('.checkboxAll').each(function() {
				$(".checkboxAll").prop('checked', true);
			})
		} else {
			// console.log('checkedno');

			$('.checkboxAll').each(function() {
				$(".checkboxAll").prop('checked', false);
			})
		}
	});


	$(".checkboxAll_c").click(function() {
		// console.log($(".checkboxAll_c:checked").length);
		var number_c = $(".checkboxAll_c:checked").length;
		if (number_c > 4) {
			$("#err1").show().delay(5000).fadeOut();
			$(this).prop('checked', false);
		}
		// var country_number=0;
		// $('.checkboxAll_c').each(function(){
		// 	$(".checkboxAll").prop('checked', true);
		// })
	});
	$(".btn-comper").click(function() {
		// console.log('btn-comper');
		var number_t = $(".checkboxAll:checked").length;
		var number_c = $(".checkboxAll_c:checked").length;
		if (number_c < 1) {
			// console.log('error 1');
			$("#err3").show().delay(5000).fadeOut();

		} else if (number_t < 1) {
			// console.log('error 2');
			$("#err2").show().delay(5000).fadeOut();

		} else {
			var cb_city = [];
			var cb_type = [];
			$(".checkboxAll_c:checked").each(function() {
				cb_city.push($(this).val());
			});
			$(".checkboxAll:checked").each(function() {
				cb_type.push($(this).val());
			});

			if ($("#selectAll").prop('checked')) {
				// console.log('checked all');
				cb_type.shift(); // delete first input value - Choose All 
			}

			// console.log('cb_type ',cb_type); 
			// console.log('cb_city ',cb_city);

			var ajaxurl = "index.php?dir=site&page=countries&op=returncountry";
			$.ajax({
				url: ajaxurl,
				method: "POST",
				data: {
					cb_city: cb_city,
					cb_type: cb_type
				},
				success: function(data) {
					// alert(data);
					$("#warp_table_compere").hide().html(data).fadeIn('fust');

				},
				error: function(request, status, error) {
					alert(request.responseText);
				}
			});


		}


	});



});